export default __webpack_public_path__ + "static/media/beyond_the_web-1.e564a4da.png";